/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/prop-types */
/* eslint-disable no-return-assign */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useRef, useContext } from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import { FaChevronCircleRight } from '@react-icons/all-files/fa/FaChevronCircleRight';
import { FaRegClock } from '@react-icons/all-files/fa/FaRegClock';

import Button from 'gatsby-core-theme/src/components/atoms/button';
import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';
import { translate } from 'gatsby-core-theme/src/helpers/getters';
import { truncateString } from 'gatsby-core-theme/src/helpers/strings';
import Link from 'gatsby-core-theme/src/hooks/link';
import { Context } from '~context/TranslationsProvider';
import { isValidEventDate, hasValidEvents } from '../../../../helpers/events';

import styles from './leagues.module.scss';

const Leagues = ({ items, sport, isStorybook = false }) => {
  const { translations } = useContext(Context) || {};
  const itemRefs = useRef([]);
  const btnRefs = useRef([]);

  const closeOtherItems = (index) => {
    for (let i = 0; i < itemRefs.current.length; i += 1) {
      if (i !== index) {
        itemRefs.current[i].classList.remove(styles.active);
        btnRefs.current[i].classList.remove(styles.active);
      }
    }
  };

  const toggle = (index) => {
    btnRefs.current[index].classList.toggle(styles.active);
    itemRefs.current[index].classList.toggle(styles.active);
    closeOtherItems(index);
  };

  return (
    <>
      {items.map((league, index) => (
        <React.Fragment key={league.id}>
          {hasValidEvents(league) && (
            <div key={league.id} className={styles.leagueItem}>
              <button
                onClick={() => toggle(index)}
                className={`${styles.leagueBtn} leagues-cta btn-cta`}
                type="button"
                ref={(el) => (btnRefs.current[index] = el)}
              >
                <span className={styles.leagueBtnRow}>
                  {league.country_code && (
                    <div>
                      <LazyImage
                        src={
                          league.country_code !== 'international' && league.country_code !== 'int'
                            ? isStorybook
                              ? `./${league.country_code}.svg`
                              : `../../../../../images/flags/${league.country_code}.svg`
                            : '../../../../../images/cl.png'
                        }
                        alt={league.name}
                        width={24}
                        height={16}
                      />
                    </div>
                  )}
                  <span className={styles.leagueRow}>
                    {league.name}
                    <span>
                      {`(${league.events.length} ${
                        league.events.length > 1
                          ? `${translate(translations, 'match_3', 'matches')}`
                          : `${translate(translations, 'match', 'match')}`
                      })`}
                    </span>
                  </span>
                </span>
                <LazyLoad height="18px" width="18px" offset={200} debounce={0}>
                  <i />
                </LazyLoad>
              </button>
              <div className={styles.leagueContent} ref={(el) => (itemRefs.current[index] = el)}>
                <ul>
                  {league?.events.map((event) => (
                    <React.Fragment key={event.id}>
                      {isValidEventDate(event?.date) && (
                        <li key={event.id} className={styles.eventItem}>
                          <Link to={event?.path || '#'} className="leagues-gtm image-cta">
                            <span className={styles.eventRow}>
                              <LazyLoad height="24px" width="61px" offset={200} debounce={0}>
                                <span>
                                  <FaRegClock />
                                  {` ${event.date.time}`}
                                </span>
                              </LazyLoad>
                              <span className={styles.teamNames}>
                                {` 
                     ${truncateString(`${event.home_team.name}`, 20)}
                      -
                      ${truncateString(`${event.away_team.name}`, 20)} `}
                              </span>
                            </span>
                            <LazyLoad height="30px" width="127px" offset={200} debounce={0}>
                              <Button
                                isAnchorLink
                                to={event?.path || '#'}
                                className={sport}
                                btnText={
                                  <>
                                    {`${translate(translations, 'watch_live', 'Watch Live')} `}
                                    <FaChevronCircleRight />
                                  </>
                                }
                                gtmClass="leagues-gtm btn-cta"
                              />
                            </LazyLoad>
                          </Link>
                        </li>
                      )}
                    </React.Fragment>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </React.Fragment>
      ))}
    </>
  );
};

Leagues.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  sport: PropTypes.string,
};

export default Leagues;
